import React from "react";
import { Button } from "../ui/button";
import { Bot } from "lucide-react";
import { cn } from "../../lib/utils";

interface ChatButtonProps {
  onClick: () => void;
  isOpen?: boolean;
  variant?: "floating" | "footer";
}

export function ChatButton({ onClick, isOpen = false, variant = "floating" }: ChatButtonProps) {
  if (variant === "footer") {
    return (
      <Button
        onClick={onClick}
        className={cn(
          "h-10 w-10 rounded-full shadow-sm",
          "bg-accent hover:bg-accent text-white",
          "transition-all duration-200",
          isOpen && "scale-95 opacity-50"
        )}
        size="icon"
        aria-label="Open AI Chat"
      >
        <Bot className="h-4 w-4" />
      </Button>
    );
  }

  return (
    <Button
      onClick={onClick}
      className={cn(
        "fixed bottom-16 right-20 h-14 w-14 rounded-full shadow-lg z-50",
        "bg-accent hover:bg-accent text-white",
        "transition-all duration-200",
        isOpen && "scale-95 opacity-50"
      )}
      size="icon"
      aria-label="Open AI Chat"
    >
      <Bot className="h-6 w-6" />
    </Button>
  );
}

